'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var nthHookTheme = require('@narvar/nth-hook-theme');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultHeaderStyle = {
  margin: '0',
  fontFamily: 'inherit',
  fontWeight: 'bold',
  color: '#000'
};
var HugeHeaderStyled = styled.h1.withConfig({
  componentId: "sc-1szdkpb-0"
})(function (_ref) {
  var s = _ref.s;
  return s;
});
var HugeHeader = function HugeHeader(_ref2) {
  var containerCustomStyle = _ref2.containerCustomStyle,
    children = _ref2.children,
    as = _ref2.as;
  var _useTheme = nthHookTheme.useTheme(),
    hugeHeaderStyle = _useTheme.headersHugeNone;
  return /*#__PURE__*/React.createElement(HugeHeaderStyled, {
    as: as,
    s: _objectSpread(_objectSpread(_objectSpread({
      fontSize: '6rem'
    }, defaultHeaderStyle), containerCustomStyle), hugeHeaderStyle)
  }, children);
};
var BigHeaderStyled = styled.h2.withConfig({
  componentId: "sc-1szdkpb-1"
})(function (_ref3) {
  var s = _ref3.s;
  return s;
});
var BigHeader = function BigHeader(_ref4) {
  var containerCustomStyle = _ref4.containerCustomStyle,
    children = _ref4.children,
    as = _ref4.as;
  var _useTheme2 = nthHookTheme.useTheme(),
    bigHeaderStyle = _useTheme2.headersBigNone;
  return /*#__PURE__*/React.createElement(BigHeaderStyled, {
    as: as,
    s: _objectSpread(_objectSpread(_objectSpread({
      fontSize: '2.125rem'
    }, defaultHeaderStyle), containerCustomStyle), bigHeaderStyle)
  }, children);
};
var SemibigHeaderStyled = styled.h3.withConfig({
  componentId: "sc-1szdkpb-2"
})(function (_ref5) {
  var s = _ref5.s;
  return s;
});
var SemibigHeader = function SemibigHeader(_ref6) {
  var containerCustomStyle = _ref6.containerCustomStyle,
    children = _ref6.children,
    as = _ref6.as;
  var _useTheme3 = nthHookTheme.useTheme(),
    semibigHeaderStyle = _useTheme3.headersSemibigNone;
  return /*#__PURE__*/React.createElement(SemibigHeaderStyled, {
    as: as,
    s: _objectSpread(_objectSpread(_objectSpread({
      fontSize: '1.5rem'
    }, defaultHeaderStyle), containerCustomStyle), semibigHeaderStyle)
  }, children);
};
var MediumHeaderStyled = styled.h4.withConfig({
  componentId: "sc-1szdkpb-3"
})(function (_ref7) {
  var s = _ref7.s;
  return s;
});
var MediumHeader = function MediumHeader(_ref8) {
  var containerCustomStyle = _ref8.containerCustomStyle,
    children = _ref8.children,
    as = _ref8.as;
  var _useTheme4 = nthHookTheme.useTheme(),
    mediumHeaderStyle = _useTheme4.headersMediumNone;
  return /*#__PURE__*/React.createElement(MediumHeaderStyled, {
    as: as,
    s: _objectSpread(_objectSpread(_objectSpread({
      fontSize: '1.125rem'
    }, defaultHeaderStyle), containerCustomStyle), mediumHeaderStyle)
  }, children);
};
var SmallHeaderStyled = styled.h5.withConfig({
  componentId: "sc-1szdkpb-4"
})(function (_ref9) {
  var s = _ref9.s;
  return s;
});
var SmallHeader = function SmallHeader(_ref10) {
  var containerCustomStyle = _ref10.containerCustomStyle,
    children = _ref10.children,
    as = _ref10.as;
  var _useTheme5 = nthHookTheme.useTheme(),
    smallHeaderStyle = _useTheme5.headersSmallNone;
  return /*#__PURE__*/React.createElement(SmallHeaderStyled, {
    as: as,
    s: _objectSpread(_objectSpread(_objectSpread({
      fontSize: '0.875rem'
    }, defaultHeaderStyle), containerCustomStyle), smallHeaderStyle)
  }, children);
};
HugeHeader.defaultProps = {
  containerCustomStyle: undefined,
  children: undefined,
  as: undefined
};
HugeHeader.propTypes = {
  containerCustomStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired),
  children: PropTypes.node,
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span', 'div'])
};
BigHeader.propTypes = HugeHeader.propTypes;
SemibigHeader.propTypes = HugeHeader.propTypes;
MediumHeader.propTypes = HugeHeader.propTypes;
SmallHeader.propTypes = HugeHeader.propTypes;
var ThemedHugeHeader = nthHookTheme.withThemeProvider(HugeHeader, {
  themeTokens: ['headersHugeNone']
});
var ThemedBigHeader = nthHookTheme.withThemeProvider(BigHeader, {
  themeTokens: ['headersBigNone']
});
var ThemedSemibigHeader = nthHookTheme.withThemeProvider(SemibigHeader, {
  themeTokens: ['headersSemibigNone']
});
var ThemedMediumHeader = nthHookTheme.withThemeProvider(MediumHeader, {
  themeTokens: ['headersMediumNone']
});
var ThemedSmallHeader = nthHookTheme.withThemeProvider(SmallHeader, {
  themeTokens: ['headersSmallNone']
});

exports.BigHeader = ThemedBigHeader;
exports.HugeHeader = ThemedHugeHeader;
exports.MediumHeader = ThemedMediumHeader;
exports.SemibigHeader = ThemedSemibigHeader;
exports.SmallHeader = ThemedSmallHeader;
